module.exports = __webpack_public_path__ + "static/media/filterDown.33de0aeb.svg";